import { FormControlLabel, FormControlLabelProps, SxProps, Theme } from '@mui/material';
import { ChangeEvent, FC, ReactNode } from 'react';
import { VySwitch as OldVySwitch } from './VySwitch';
import { SIZES } from '../../types/sizes';

type VySwitchProps = {
  checked?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  label?: ReactNode;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  disabled?: boolean;
  labelWrapperSx?: SxProps<Theme>;
};

export const VySwitch: FC<VySwitchProps> = ({
  checked,
  onChange,
  label,
  labelPlacement,
  disabled,
  labelWrapperSx = {},
}) => (
  <FormControlLabel
    sx={labelWrapperSx}
    disabled={disabled}
    control={<OldVySwitch checked={checked} onChange={onChange} size={SIZES.SMALL} />}
    label={label}
    labelPlacement={labelPlacement}
  />
);
